import React, { useState, useEffect, useCallback } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Loader2 } from 'lucide-react';
import Header from '../components/common/Header';
import AuthForm from '../components/auth/AuthForm';
import { IN_APP_FOOTER_LINKS } from './public/publicFooterLinks';

const HomePage = () => {
  const navigate = useNavigate();
  const { isAuthenticated, isLoading, needsConfirmation } = useAuth();

  const [authState, setAuthState] = useState({
    isSignUp: true,
    showConfirmation: false
  });

  // Debug current state
  useEffect(() => {
    console.log('HomePage authState:', authState);
    console.log('HomePage needsConfirmation:', needsConfirmation);
  }, [authState, needsConfirmation]);

  // Redirect if already authenticated
  useEffect(() => {
    if (isAuthenticated) {
      navigate('/select-project');
    }
  }, [isAuthenticated, navigate]);

  // Ensure confirmation state is preserved
  useEffect(() => {
    if (needsConfirmation && !authState.showConfirmation) {
      console.log('Setting confirmation state from needsConfirmation');
      setAuthState(prev => ({
        ...prev,
        showConfirmation: true
      }));
    }
  }, [needsConfirmation, authState.showConfirmation]);

  const handleAuthStateChange = useCallback((state: { isSignUp: boolean; showConfirmation: boolean }) => {
    console.log('Auth state change received:', state);
    setAuthState(state);
  }, []);

  const handleAuthSuccess = () => {
    // Additional logic can be added here if needed
    // Navigation is handled by the AuthContext automatically
    console.log('Auth success callback triggered');
  };

  return (
    <div className="min-h-screen bg-white dark:bg-neutral-950 text-neutral-900 dark:text-white flex flex-col">
      <Header type="homepage" />

      {/* Main Content */}
      <main className="flex-1 flex items-center justify-center px-4 sm:px-6 lg:px-8 py-12">
        <div className="max-w-md w-full space-y-8">
          <AuthForm
            onSuccess={handleAuthSuccess}
            onStateChange={handleAuthStateChange}
          />

        </div>
      </main>

      {/* Public storefront links (pricing + legal) — required for Paddle's website review */}
      {process.env.REACT_APP_SHOW_PUBLIC_PAGES === 'true' && (
        <footer className="py-6 px-4">
          <nav className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2">
            {IN_APP_FOOTER_LINKS.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className="text-sm text-neutral-500 dark:text-neutral-400 hover:text-neutral-900 dark:hover:text-white transition-colors"
              >
                {link.label}
              </Link>
            ))}
          </nav>
        </footer>
      )}
    </div>
  );
};

export default HomePage;